module.exports = __webpack_public_path__ + "static/img/14.e98e04f3.png";